module.exports = __webpack_public_path__ + "img/photo-29.abbedb8e.jpg";